import { FacebookEventNames } from '../../entities';
import { FacebookService } from '../../interfaces';

export class FacebookServiceDecorator implements FacebookService {
  constructor(protected readonly facebookService: FacebookService) {}

  isFbqAvailable() {
    return this.facebookService.isFbqAvailable();
  }

  isFbqRequired() {
    return this.facebookService.isFbqRequired();
  }

  track(name: FacebookEventNames, orderId: string, params?: Record<string, unknown>) {
    return this.facebookService.track(name, orderId, params);
  }
}
